import React from 'react';
import { MappingRow } from './MappingRow';

export const MappingForm = ({ mapping, setMapping, roleOptions, pagesOptions }) => {
  const updateRow = (updatedRow) => {
    const updated = mapping.map((row) => (row.id === updatedRow.id ? { ...updatedRow } : row));
    const isLastRow = mapping[mapping.length - 1].id === updatedRow.id;
    if (isLastRow) {
      updated.push({
        id: `new-${Date.now()}`,
        key: '',
        value: '',
        environment: updatedRow.environment || 'PRODUCTION',
      });
    }
    setMapping(updated);
  };
  return (
    <div className="table">
      <table className="table table-sm table-bordered table-condensed">
        <thead style={{ fontWeight: 'bold' }}>
          <tr>
            <td className="text-left">Role</td>
            <td className="text-left">Page</td>
          </tr>
        </thead>
        <tbody>
          {mapping.map((row) => (
            <MappingRow
              key={row.id}
              row={row}
              updateRow={updateRow}
              roleOptions={roleOptions}
              pagesOptions={pagesOptions}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};
